import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import {
    chooseWXPay,
} from '@/lib/script/pay';


export interface HuangshanState {
    graduationInfo: Huangshan.UserGraduationInfo |null;
}

const m: Module<HuangshanState, RootState> = {
    namespaced: true,
    state: () => ({
        graduationInfo: null,
    }),
    mutations: {
        setGraduationInfo(state, graduationInfo) {
            state.graduationInfo = graduationInfo;
        },
    },
    actions: {
        /**
         * 获取报名毕业跑的信息
         */
        async getGraduationInfo({ state, commit }, forceUpdate?: boolean) {
            if (state.graduationInfo && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/graduation/order');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setGraduationInfo', rdata.data);
            }
            return rdata;
        },
        /**
         * 保存个人信息
         * @param name 姓名
         * @param mobile 手机号
         * @param certificateType 证件类型
         * @param id 证件号
         * @param gender 性别
         * @param bloodType 血型
         * @param size 衣服尺码
         * @param emergencyContact 紧急联系人
         * @param emergencyContactMobile 紧急联系电话
         * @param referrer 推荐人
         */
        async saveUserInfo({ state, commit }, { name, mobile, certificateType, id, gender, bloodType, size, emergencyContact, emergencyContactMobile, referrer }: { name: string, mobile: string, certificateType: string, id: string, gender: string, bloodType: string, size: string, emergencyContact: string, emergencyContactMobile: string, referrer: string }) {
            const response = await Vue.axios.post('/api/v1/graduation/user_info', {
                name,
                mobile,
                id_type: certificateType,
                id_number: id,
                sex: gender,
                blood_type: bloodType,
                clothing_size: size,
                emergency_contact: emergencyContact,
                emergency_contact_mobile: emergencyContactMobile,
                referrer,
            });
            const rdata = response.data;
            return rdata;
        },
        /**
         * 下单报名参加毕业跑
         */
        async createOrder({ state, commit }) {
            const orderResponse = await Vue.axios.post('/api/v1/graduation/order');
            const orderRdata = orderResponse.data;
            return orderRdata;
        },
        /**
         * 支付
         *
         * @param {} orderId 订单号
         * @return {} rdata
         */
        async pay(context, orderId: string) {
            const payResponse = await Vue.axios.post('/api/v1/graduation/pay', {
                order_id: orderId,
            });
            const payRdata = payResponse.data;
            const ret = await chooseWXPay(payRdata.data.params);
            ret.type = 'jsapi';
            ret.orderId = orderId;
            return ret;
        },
        /**
         * 支付状态检查
         *
         * @param {} orderId 订单号
         * @return {} rdata
         */
        async payStatus(context, orderId: string) {
            const response = await Vue.axios.get('/api/v1/graduation/order_status', {
                params: {
                    order_id: orderId,
                },
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
